import request from "@/utils/request";
export default {
queryBookCover(page,pageSize,data) {
    return request.post("/api/school-batch-books/list?page="+page+"&pageSize="+pageSize,data);
},
searchPage(page,pageSize,data) {
    return request.post("/api/school-batch-books/page/search?page="+page+"&pageSize="+pageSize,data);
}
}